/** Created by azhou on 2019/3/21.*/
<template>
  <div class="bg-white box-shadow d-center-around pl-3 pr-3 pt-5 pb-5 mb-4 rounded blank-head">
    <div class="w-25 border-right">门店余额
      <div class="d-end-center">
        <h3 class="h3 text-link mt-3" @click="goForDetail('allowWithdraw')">
          &yen; {{StoreMoneyInfo.total_money | formatMoney}}
        </h3>
        <span class="text-link ml-2 h5 font-weight-normal" v-if="StoreMoneyInfo.total_money>0"
              @click="$router.push({name:'FinancialLists',query:{tab:'allowWithdraw',page:1}})">去提现</span>
      </div>
    </div>
    <div class="w-25 border-right">冻结金额
      <el-tooltip class="item" effect="dark" content="平台审核打款中..." placement="bottom"
                  v-show="StoreMoneyInfo.freeze_money > 0">
        <i class="el-icon-question"></i>
      </el-tooltip>
      <h3 class="h3 text-link mt-3" @click="goForDetail('Freezing')">&yen; {{StoreMoneyInfo.freeze_money | formatMoney}}</h3>
    </div>
    <div class="w-25 border-right">累计{{userInfo.type === 2 ? '付' : '收'}}款
      <h3 class="h3 text-link mt-3" @click="goForDetail('all')">&yen; {{(StoreMoneyInfo.trade_detail_money || StoreMoneyInfo.allMoney) | formatMoney}}</h3>
    </div>
    <div class="w-25">累计提现
      <h3 class="h3 text-link mt-3" @click="goForDetail('WithdrawDone')">&yen; {{StoreMoneyInfo.put_forward_money | formatMoney}}</h3>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'TotalListHead',
    computed: {
      ...mapState(['StoreMoneyInfo']),
      ...mapGetters(['userInfo'])
    },
    methods:{
      //资金详细项点击跳转
      goForDetail(flag) {
        this.$router.replace({name:this.$route.name,
          query:{
            ...this.$route.query,
            tab:flag
        }})
      },
    }
  }
</script>
